import { useState, useEffect, useRef } from 'react'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import Loader from 'react-loaders'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faGithub,
  faInstagram,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons'
import emailjs from '@emailjs/browser'

const Contact = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const form = useRef()

  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  const sendEmail = (e) => {
    e.preventDefault()

    emailjs
      .sendForm(
        'service_483f77e',
        'template_k3oyrd9',
        form.current,
        '-r9eRHv5mVZGa6e2e'
      )
      .then(
        () => {
          alert('Message successfully sent!')
          window.location.reload(false)
        },
        () => {
          alert('Failed to send the message, please try again')
        }
      )
  }
  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'M', 'e']}
              idx={15}
            />
          </h1>

          <ul className="socialUl">
            <li className="socialSvg">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.linkedin.com/in/saerom-hong-786665270/"
              >
                <FontAwesomeIcon icon={faLinkedin} color="#fff" />
              </a>
            </li>
            <li className="socialSvg">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://github.com/s1romy"
              >
                <FontAwesomeIcon icon={faGithub} color="#fff" />
              </a>
            </li>
            <li className="socialSvg">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.instagram.com/_siromi/"
              >
                <FontAwesomeIcon icon={faInstagram} color="#fff" />
              </a>
            </li>
          </ul>
          <p>Leave a message</p>
          <div className="contact-form">
            <form ref={form} onSubmit={sendEmail}>
              <ul>
                <li className="half">
                  <input type="text" name="name" placeholder="Name" required />
                </li>
                <li className="half">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    required
                  />
                </li>
                <li>
                  <input
                    placeholder="Subject"
                    type="text"
                    name="subject"
                    required
                  />
                </li>
                <li>
                  <textarea
                    placeholder="Message"
                    name="message"
                    required
                  ></textarea>
                </li>
                <li>
                  <input type="submit" className="flat-button" value="SEND" />
                </li>
              </ul>
            </form>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Contact
